import { UserState } from 'src/app/global/state/app.reducers';
import { PtState } from './pt.reducer';
import * as PtActions from './pt.actions';
import * as PtSelectors from './pt.selectors';

export interface State extends UserState {
    ptState: PtState
}

export { PtActions, PtSelectors };